import React from 'react'
import { InternalErrorPage } from './internal-error'
import { ForbiddenPage } from './forbidden'
import { ForbiddenError, NotFoundError } from '../../modules/shared/exceptions'
import NotFoundPage from './not-found'

export function ErrorPageSelector({ error, resetError }: { error: any; resetError: () => void }): JSX.Element {
  if (error instanceof ForbiddenError) {
    return <ForbiddenPage error={error} resetError={resetError} />
  } else if (error instanceof NotFoundError) {
    return <NotFoundPage resetError={resetError} />
  }

  return <InternalErrorPage error={error} resetError={resetError} />
}
